// Dosis yang tercatat langsung sebagai tipe vaksin ini.
// Catatan backend: item completeVaccinations tidak punya id yang bisa dipercaya
// (kolom id/created_at ambigu karena join) dan belum membawa merek vaksin,
// jadi key memakai index dan merek hanya tampil bila backend menambahkannya.
const toOwnRow = (item, index) => ({
  key: `own-${index}`,
  kind: "own",
  date_taken: item?.date_taken,
  vaccine_name: item?.vaccine?.brand_name ?? item?.brand_name ?? null,
  batch: item?.batch ?? null,
  note: null,
});

// Dosis yang diberikan sebagai tipe vaksin lain tetapi ikut dihitung di sini
// (MR dihitung untuk Campak, MMR untuk MR dan Campak).
const toOverlapRow = (item, index) => ({
  key: `overlap-${item?.vaccination_id ?? index}`,
  kind: "overlap",
  date_taken: item?.date_taken,
  vaccine_name: item?.source_vaccine_type_name ?? null,
  batch: null,
  note: item?.note ?? null,
});

export const buildProgressRows = (type) => {
  const own = (type?.completeVaccinations || []).map(toOwnRow);
  const overlap = (type?.overlap_doses || []).map(toOverlapRow);

  // sort() stabil di Node 11+ / browser modern, jadi urutan input tetap untuk tanggal sama
  return [...own, ...overlap].sort((a, b) =>
    String(a.date_taken || "").localeCompare(String(b.date_taken || "")),
  );
};

// frequency dari backend sudah max(default_frequency, count_finish), jadi
// jumlah dosis nyata tidak pernah dipotong. Fallback untuk field yang belum ada.
export const getProgressSummary = (type) => {
  const rows = buildProgressRows(type);
  const countFinish = type?.count_finish ?? rows.length;
  const defaultFrequency = type?.default_frequency ?? type?.frequency ?? 0;
  const frequency = type?.frequency ?? Math.max(defaultFrequency, countFinish);

  return {
    countFinish,
    frequency,
    defaultFrequency,
    isOverSchedule: countFinish > defaultFrequency,
    isComplete: frequency > 0 && countFinish >= frequency,
    hasOverlap: (type?.overlap_doses || []).length > 0,
  };
};
